export function getScoreboardTypes(): string[] {
    return ['IBJJF', 'ADCC', 'EBI']
}

export function getTimeslots(): { id: number; time: string }[] {
    return [
        { id: 1, time: '01:00:00' },
        { id: 2, time: '02:00:00' },
        { id: 3, time: '03:00:00' },
        { id: 4, time: '04:00:00' },
        { id: 5, time: '05:00:00' },
        { id: 6, time: '06:00:00' },
        { id: 7, time: '07:00:00' },
        { id: 8, time: '08:00:00' },
        { id: 9, time: '09:00:00' },
        { id: 10, time: '10:00:00' },
        { id: 11, time: '11:00:00' },
        { id: 12, time: '12:00:00' },
        { id: 13, time: '13:00:00' },
        { id: 14, time: '14:00:00' },
        { id: 15, time: '15:00:00' },
        { id: 16, time: '16:00:00' },
        { id: 17, time: '17:00:00' },
        { id: 18, time: '18:00:00' },
        { id: 19, time: '19:00:00' },
        { id: 20, time: '20:00:00' },
        { id: 21, time: '21:00:00' },
        { id: 22, time: '22:00:00' },
        { id: 23, time: '23:00:00' }
    ]
}

export function getRanks() {
    return [
        {
            label: 'Kids',
            options: [
                'White',
                'Grey and White',
                'Grey',
                'Grey and Black',
                'Yellow and White',
                'Yellow',
                'Yellow and Black',
                'Orange and White',
                'Orange',
                'Orange and Black',
                'Green and White',
                'Green',
                'Green and Black'
            ]
        },
        {
            label: 'Adults',
            options: [
                'White Belt',
                'Blue Belt',
                'Purple Belt',
                'Brown Belt',
                'Black Belt',
                'Coral Belt'
            ]
        }
    ]
}

export function getTimezones() {
    return [
        { timezone: 'Pacific/Midway', time: 'GMT-11:00' },
        { timezone: 'America/Adak', time: 'GMT-10:00' },
        { timezone: 'Etc/GMT', time: 'GMT-10:00' },
        { timezone: 'Pacific/Marquesas', time: 'GMT-09:30' },
        { timezone: 'Pacific/Gambier', time: 'GMT-09:00' },
        { timezone: 'America/Anchorage', time: 'GMT-09:00' },
        { timezone: 'America/Ensenada', time: 'GMT-08:00' },
        { timezone: 'Etc/GMT', time: 'GMT-08:00' },
        { timezone: 'America/Los_Angeles', time: 'GMT-08:00' },
        { timezone: 'America/Denver', time: 'GMT-07:00' },
        { timezone: 'America/Chihuahua', time: 'GMT-07:00' },
        { timezone: 'America/Dawson_Creek', time: 'GMT-07:00' },
        { timezone: 'America/Belize', time: 'GMT-06:00' },
        { timezone: 'America/Cancun', time: 'GMT-06:00' },
        { timezone: 'Chile/EasterIsland', time: 'GMT-06:00' },
        { timezone: 'America/Chicago', time: 'GMT-06:00' },
        { timezone: 'America/New_York', time: 'GMT-05:00' },
        { timezone: 'America/Havana', time: 'GMT-05:00' },
        { timezone: 'America/Bogota', time: 'GMT-05:00' },
        { timezone: 'America/Caracas', time: 'GMT-04:30' },
        { timezone: 'America/Santiago', time: 'GMT-04:00' },
        { timezone: 'America/La_Paz', time: 'GMT-04:00' },
        { timezone: 'Atlantic/Stanley', time: 'GMT-04:00' },
        { timezone: 'America/Campo_Grande', time: 'GMT-04:00' },
        { timezone: 'America/Goose_Bay', time: 'GMT-04:00' },
        { timezone: 'America/Glace_Bay', time: 'GMT-04:00' },
        { timezone: 'America/St_Johns', time: 'GMT-03:30' },
        { timezone: 'America/Araguaina', time: 'GMT-03:00' },
        { timezone: 'America/Montevideo', time: 'GMT-03:00' },
        { timezone: 'America/Miquelon', time: 'GMT-03:00' },
        { timezone: 'America/Godthab', time: 'GMT-03:00' },
        { timezone: 'America/Argentina', time: 'GMT-03:00' },
        { timezone: 'America/Sao_Paulo', time: 'GMT-03:00' },
        { timezone: 'America/Noronha', time: 'GMT-02:00' },
        { timezone: 'Atlantic/Cape_Verde', time: 'GMT-01:00' },
        { timezone: 'Atlantic/Azores', time: 'GMT-01:00' },
        { timezone: 'Europe/Belfast', time: 'GMT) Gree' },
        { timezone: 'Europe/Dublin', time: 'GMT) Gree' },
        { timezone: 'Europe/Lisbon', time: 'GMT) Gree' },
        { timezone: 'Europe/London', time: 'GMT) Gree' },
        { timezone: 'Africa/Abidjan', time: 'GMT) Monr' },
        { timezone: 'Europe/Amsterdam', time: 'GMT+01:00' },
        { timezone: 'Europe/Belgrade', time: 'GMT+01:00' },
        { timezone: 'Europe/Brussels', time: 'GMT+01:00' },
        { timezone: 'Africa/Algiers', time: 'GMT+01:00' },
        { timezone: 'Africa/Windhoek', time: 'GMT+01:00' },
        { timezone: 'Asia/Beirut', time: 'GMT+02:00' },
        { timezone: 'Africa/Cairo', time: 'GMT+02:00' },
        { timezone: 'Asia/Gaza', time: 'GMT+02:00' },
        { timezone: 'Africa/Blantyre', time: 'GMT+02:00' },
        { timezone: 'Asia/Jerusalem', time: 'GMT+02:00' },
        { timezone: 'Europe/Minsk', time: 'GMT+02:00' },
        { timezone: 'Asia/Damascus', time: 'GMT+02:00' },
        { timezone: 'Europe/Moscow', time: 'GMT+03:00' },
        { timezone: 'Africa/Addis_Ababa', time: 'GMT+03:00' },
        { timezone: 'Asia/Tehran', time: 'GMT+03:30' },
        { timezone: 'Asia/Dubai', time: 'GMT+04:00' },
        { timezone: 'Asia/Yerevan', time: 'GMT+04:00' },
        { timezone: 'Asia/Kabul', time: 'GMT+04:30' },
        { timezone: 'Asia/Yekaterinburg', time: 'GMT+05:00' },
        { timezone: 'Asia/Tashkent', time: 'GMT+05:00' },
        { timezone: 'Asia/Kolkata', time: 'GMT+05:30' },
        { timezone: 'Asia/Katmandu', time: 'GMT+05:45' },
        { timezone: 'Asia/Dhaka', time: 'GMT+06:00' },
        { timezone: 'Asia/Novosibirsk', time: 'GMT+06:00' },
        { timezone: 'Asia/Rangoon', time: 'GMT+06:30' },
        { timezone: 'Asia/Bangkok', time: 'GMT+07:00' },
        { timezone: 'Asia/Krasnoyarsk', time: 'GMT+07:00' },
        { timezone: 'Asia/Hong_Kong', time: 'GMT+08:00' },
        { timezone: 'Asia/Irkutsk', time: 'GMT+08:00' },
        { timezone: 'Australia/Perth', time: 'GMT+08:00' },
        { timezone: 'Australia/Eucla', time: 'GMT+08:45' },
        { timezone: 'Asia/Tokyo', time: 'GMT+09:00' },
        { timezone: 'Asia/Seoul', time: 'GMT+09:00' },
        { timezone: 'Asia/Yakutsk', time: 'GMT+09:00' },
        { timezone: 'Australia/Adelaide', time: 'GMT+09:30' },
        { timezone: 'Australia/Darwin', time: 'GMT+09:30' },
        { timezone: 'Australia/Brisbane', time: 'GMT+10:00' },
        { timezone: 'Australia/Sydney', time: 'GMT+10:00' },
        { timezone: 'Asia/Vladivostok', time: 'GMT+10:00' },
        { timezone: 'Australia/Lord_Howe', time: 'GMT+10:30' },
        { timezone: 'Etc/GMT', time: 'GMT+11:00' },
        { timezone: 'Asia/Magadan', time: 'GMT+11:00' },
        { timezone: 'Pacific/Norfolk', time: 'GMT+11:30' },
        { timezone: 'Asia/Anadyr', time: 'GMT+12:00' },
        { timezone: 'Pacific/Auckland', time: 'GMT+12:00' },
        { timezone: 'Etc/GMT', time: 'GMT+12:00' },
        { timezone: 'Pacific/Chatham', time: 'GMT+12:45' },
        { timezone: 'Pacific/Tongatapu', time: 'GMT+13:00' },
        { timezone: 'Pacific/Kiritimati', time: 'GMT+14:00' }
    ]
}

export function getCountries(popular = false) {
    if (popular) {
        return [
            'Australia',
            'New Zealand',
            'Pakistan',
            'Thailand',
            'Vietnam',
            'United Kingdom',
            'United States'
        ]
    }

    return [
        'Afghanistan',
        'Albania',
        'Algeria',
        'American',
        'Andorra',
        'Angola',
        'Anguilla',
        'Antartica',
        'Antigua',
        'Argentina',
        'Armenia',
        'Aruba',
        'Australia',
        'Austria',
        'Azerbaijan',
        'Bahamas',
        'Bahrain',
        'Bangladesh',
        'Barbados',
        'Belarus',
        'Belgium',
        'Belize',
        'Benin',
        'Bermuda',
        'Bhutan',
        'Bolivia',
        'Bosnia',
        'Botswana',
        'Bouvet',
        'Brazil',
        'British',
        'Brunei',
        'Bulgaria',
        'Burkina',
        'Burundi',
        'Cambodia',
        'Cameroon',
        'Canada',
        'Cape',
        'Cayman',
        'Central',
        'Chad',
        'Chile',
        'China',
        'Christmas',
        'Cocos',
        'Colombia',
        'Comoros',
        'Congo',
        'Congo',
        'Cook',
        'Costa',
        'Cota',
        'Croatia',
        'Cuba',
        'Cyprus',
        'Czech',
        'Denmark',
        'Djibouti',
        'Dominica',
        'Dominican',
        'East',
        'Ecuador',
        'Egypt',
        'El',
        'Equatorial',
        'Eritrea',
        'Estonia',
        'Ethiopia',
        'Falkland',
        'Faroe',
        'Fiji',
        'Finland',
        'France',
        'France',
        'French',
        'French',
        'French',
        'Gabon',
        'Gambia',
        'Georgia',
        'Germany',
        'Ghana',
        'Gibraltar',
        'Greece',
        'Greenland',
        'Grenada',
        'Guadeloupe',
        'Guam',
        'Guatemala',
        'Guinea',
        'Guinea',
        'Guyana',
        'Haiti',
        'Heard',
        'Holy',
        'Honduras',
        'Hong',
        'Hungary',
        'Iceland',
        'India',
        'Indonesia',
        'Iran',
        'Iraq',
        'Ireland',
        'Israel',
        'Italy',
        'Jamaica',
        'Japan',
        'Jordan',
        'Kazakhstan',
        'Kenya',
        'Kiribati',
        'Democratic',
        'Korea',
        'Kuwait',
        'Kyrgyzstan',
        'Lao',
        'Latvia',
        'Lebanon',
        'Lesotho',
        'Liberia',
        'Libyan',
        'Liechtenstein',
        'Lithuania',
        'Luxembourg',
        'Macau',
        'Macedonia',
        'Madagascar',
        'Malawi',
        'Malaysia',
        'Maldives',
        'Mali',
        'Malta',
        'Marshall',
        'Martinique',
        'Mauritania',
        'Mauritius',
        'Mayotte',
        'Mexico',
        'Micronesia',
        'Moldova',
        'Monaco',
        'Mongolia',
        'Montserrat',
        'Morocco',
        'Mozambique',
        'Myanmar',
        'Namibia',
        'Nauru',
        'Nepal',
        'Netherlands',
        'Netherlands',
        'New',
        'New',
        'Nicaragua',
        'Niger',
        'Nigeria',
        'Niue',
        'Norfolk',
        'Northern',
        'Norway',
        'Oman',
        'Pakistan',
        'Palau',
        'Panama',
        'Papua',
        'Paraguay',
        'Peru',
        'Philippines',
        'Pitcairn',
        'Poland',
        'Portugal',
        'Puerto',
        'Qatar',
        'Reunion',
        'Romania',
        'Russia',
        'Rwanda',
        'Saint',
        'Saint',
        'Saint',
        'Samoa',
        'San',
        'Sao',
        'Saudi',
        'Senegal',
        'Seychelles',
        'Sierra',
        'Singapore',
        'Slovakia',
        'Slovenia',
        'Solomon',
        'Somalia',
        'South',
        'South',
        'Span',
        'SriLanka',
        'St',
        'St',
        'Sudan',
        'Suriname',
        'Svalbard',
        'Swaziland',
        'Sweden',
        'Switzerland',
        'Syria',
        'Taiwan',
        'Tajikistan',
        'Tanzania',
        'Thailand',
        'Togo',
        'Tokelau',
        'Tonga',
        'Trinidad',
        'Tunisia',
        'Turkey',
        'Turkmenistan',
        'Turks',
        'Tuvalu',
        'Uganda',
        'Ukraine',
        'United',
        'United',
        'United',
        'United',
        'Uruguay',
        'Uzbekistan',
        'Vanuatu',
        'Venezuela',
        'Vietnam',
        'Virgin',
        'Virgin',
        'Wallis',
        'Western',
        'Yemen',
        'Yugoslavia',
        'Zambia',
        'Zimbabwe'
    ]
}
